var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddMedia = function SvgAddMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.343 35.243h-6.675V29.71c0-.97-.741-1.711-1.711-1.711H30.71A1.68 1.68 0 0 0 29 29.71v32.336c0 .97.742 1.711 1.711 1.711h6.105v5.532c0 .97.741 1.711 1.71 1.711h41.76a1.68 1.68 0 0 0 1.711-1.71V36.953c.057-.913-.742-1.711-1.654-1.711Zm-23.96-1.654a5.088 5.088 0 0 1 5.077 5.075 5.088 5.088 0 0 1-5.077 5.076 5.088 5.088 0 0 1-5.077-5.076 5.088 5.088 0 0 1 5.077-5.075Zm-18.94 24.01c-.627 0-1.198-.343-1.54-.913a1.78 1.78 0 0 1 .114-1.768l10.04-14.6c.343-.456.856-.741 1.426-.741s1.084.285 1.427.741l6.674 9.695 2.852-3.535c.343-.4.8-.628 1.313-.628.513 0 1.026.228 1.312.627l6.674 8.327c.4.513.514 1.197.228 1.825-.285.57-.912.97-1.54.97h-28.98Zm41.188 9.98H40.238v-3.822H71.9a1.68 1.68 0 0 0 1.711-1.71V38.663h4.963v28.914h.057Z",
    fill: "#1D352A",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 24.5,
    r: 9.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 24.5,
    r: 7.917,
    fill: "#1D352A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.313 19.75h2.375v9.5h-2.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.75 25.688v-2.375h9.5v2.375z"
  }))));
};
export default SvgAddMedia;